import { useEffect, useMemo, useState } from 'react';
import useApi from './useApi.hook';
import { templatesRegistryUrl } from '../helpers/constants';

// The registry is static per backend release, so one request serves the whole tab.
const NO_TEMPLATES = [];
let cachedGroups = null;
let pendingRequest = null;

export default function useTemplateRegistry() {
	const api = useApi();
	const [groups, setGroups] = useState(cachedGroups ?? []);
	const [error, setError] = useState(undefined);

	useEffect(() => {
		if (cachedGroups) return;
		if (!pendingRequest) {
			pendingRequest = api.get(templatesRegistryUrl)
				.then(({ data }) => {
					cachedGroups = data;
					return data;
				})
				.finally(() => {
					pendingRequest = null;
				});
		}
		pendingRequest
			.then(setGroups)
			.catch((e) => setError(
				e.response?.data?.detail || e.message || 'Не удалось загрузить список шаблонов'
			));
	}, [api]);

	const byCode = useMemo(
		() => Object.fromEntries(groups.flatMap((g) => g.templates.map((t) => [t.code, t]))),
		[groups]
	);

	const groupTemplates = (groupCode) =>
		groups.find((g) => g.code === groupCode)?.templates || NO_TEMPLATES;

	return { groups, byCode, groupTemplates, error };
}
